import { Box, Button, Typography, useTheme } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import { useJitsi } from "../../contexts/VideoCallContext";

const FullScreenCallEndedScreen = () => {
  const theme = useTheme();
  const { rejoinCall, closeJitsi, appointmentUuid, minimizeJitsi } = useJitsi();
  const navigate = useNavigate();
  const location = useLocation();

  const handleRejoin = () => {
    rejoinCall();
  };

  const handleReturnToCalendar = () => {
    closeJitsi();
    navigate("/ehr/scheduling");
  };

  const handleStartVisitNote = () => {
    if (appointmentUuid) {
      minimizeJitsi();
      navigate(`/ehr/scheduling/visit-note/add/${appointmentUuid}`);
    }
  };

  return (
    <Box
      sx={{
        position: "fixed",
        top: "58px",
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "white",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        pt: 10,
        zIndex: 9999,
        gap: 2,
      }}
    >
      <Typography
        variant="h4"
        sx={{
          fontWeight: 600,
          mb: 1,
          textAlign: "center",
        }}
      >
        You've left the appointment
      </Typography>

      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          gap: 2,
          flexDirection: { xs: "column", sm: "row" },
          width: "100%",
          maxWidth: 400,
          px: 2,
        }}
      >
        <Button
          variant="outlined"
          onClick={handleRejoin}
          sx={{
            height: "34px",
            borderRadius: 2,
          }}
        >
          Rejoin
        </Button>

        <Button
          variant="contained"
          onClick={handleReturnToCalendar}
          sx={{
            height: "34px",
            backgroundColor: theme.palette.primary.main,
            borderRadius: 2,
            "&:hover": {
              backgroundColor: theme.palette.primary.dark,
            },
          }}
        >
          Return to Calendar
        </Button>
      </Box>
    </Box>
  );
};

export default FullScreenCallEndedScreen;
